/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Courier,
  DeliveryConfig,
  DeliveryFee,
  NewDeliveryConfig,
  NewDeliveryFee,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  Town,
} from '../models/index';
import {
    CourierFromJSON,
    CourierToJSON,
    DeliveryConfigFromJSON,
    DeliveryConfigToJSON,
    DeliveryFeeFromJSON,
    DeliveryFeeToJSON,
    NewDeliveryConfigFromJSON,
    NewDeliveryConfigToJSON,
    NewDeliveryFeeFromJSON,
    NewDeliveryFeeToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    TownFromJSON,
    TownToJSON,
} from '../models/index';

export interface DeliveryConfigCountRequest {
    where?: string;
}

export interface DeliveryConfigCreateRequest {
    data?: NewDeliveryConfig;
}

export interface DeliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStreamRequest {
    options?: string;
}

export interface DeliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface DeliveryConfigDeleteByIdRequest {
    id: string;
}

export interface DeliveryConfigExistsGetDeliveryConfigsidExistsRequest {
    id: string;
}

export interface DeliveryConfigExistsHeadDeliveryConfigsidRequest {
    id: string;
}

export interface DeliveryConfigFindRequest {
    filter?: string;
}

export interface DeliveryConfigFindByIdRequest {
    id: string;
    filter?: string;
}

export interface DeliveryConfigFindOneRequest {
    filter?: string;
}

export interface DeliveryConfigPatchOrCreateRequest {
    data?: DeliveryConfig;
}

export interface DeliveryConfigPrototypeCountDeliveryFeesRequest {
    id: string;
    where?: string;
}

export interface DeliveryConfigPrototypeCreateDeliveryFeesRequest {
    id: string;
    data?: NewDeliveryFee;
}

export interface DeliveryConfigPrototypeDeleteDeliveryFeesRequest {
    id: string;
}

export interface DeliveryConfigPrototypeDestroyByIdDeliveryFeesRequest {
    id: string;
    fk: string;
}

export interface DeliveryConfigPrototypeFindByIdDeliveryFeesRequest {
    id: string;
    fk: string;
}

export interface DeliveryConfigPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryConfigPrototypeGetDeliveryFeesRequest {
    id: string;
    filter?: string;
}

export interface DeliveryConfigPrototypeGetDeliveryFeesCourierRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface DeliveryConfigPrototypeGetDeliveryFeesTownsRequest {
    id: string;
    nk: string;
    refresh?: boolean;
}

export interface DeliveryConfigPrototypePatchAttributesRequest {
    id: string;
    data?: DeliveryConfig;
}

export interface DeliveryConfigPrototypeUpdateByIdDeliveryFeesRequest {
    id: string;
    fk: string;
    data?: DeliveryFee;
}

export interface DeliveryConfigReplaceByIdPostDeliveryConfigsidReplaceRequest {
    id: string;
    data?: DeliveryConfig;
}

export interface DeliveryConfigReplaceByIdPutDeliveryConfigsidRequest {
    id: string;
    data?: DeliveryConfig;
}

export interface DeliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreateRequest {
    data?: DeliveryConfig;
}

export interface DeliveryConfigReplaceOrCreatePutDeliveryConfigsRequest {
    data?: DeliveryConfig;
}

export interface DeliveryConfigUpdateAllRequest {
    where?: string;
    data?: DeliveryConfig;
}

export interface DeliveryConfigUpsertWithWhereRequest {
    where?: string;
    data?: DeliveryConfig;
}

/**
 * 
 */
export class DeliveryConfigApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryConfigCountRaw(requestParameters: DeliveryConfigCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryConfigCount(requestParameters: DeliveryConfigCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.deliveryConfigCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryConfigCreateRaw(requestParameters: DeliveryConfigCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewDeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryConfigCreate(requestParameters: DeliveryConfigCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStreamRaw(requestParameters: DeliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStream(requestParameters: DeliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryConfigCreateChangeStreamGetDeliveryConfigsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStreamRaw(requestParameters: DeliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStream(requestParameters: DeliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryConfigCreateChangeStreamPostDeliveryConfigsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryConfigDeleteByIdRaw(requestParameters: DeliveryConfigDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryConfigDeleteById(requestParameters: DeliveryConfigDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deliveryConfigDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryConfigExistsGetDeliveryConfigsidExistsRaw(requestParameters: DeliveryConfigExistsGetDeliveryConfigsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigExistsGetDeliveryConfigsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryConfigExistsGetDeliveryConfigsidExists(requestParameters: DeliveryConfigExistsGetDeliveryConfigsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryConfigExistsGetDeliveryConfigsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryConfigExistsHeadDeliveryConfigsidRaw(requestParameters: DeliveryConfigExistsHeadDeliveryConfigsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigExistsHeadDeliveryConfigsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryConfigExistsHeadDeliveryConfigsid(requestParameters: DeliveryConfigExistsHeadDeliveryConfigsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryConfigExistsHeadDeliveryConfigsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryConfigFindRaw(requestParameters: DeliveryConfigFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeliveryConfig>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeliveryConfigFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryConfigFind(requestParameters: DeliveryConfigFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeliveryConfig>> {
        const response = await this.deliveryConfigFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryConfigFindByIdRaw(requestParameters: DeliveryConfigFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryConfigFindById(requestParameters: DeliveryConfigFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryConfigFindOneRaw(requestParameters: DeliveryConfigFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryConfigFindOne(requestParameters: DeliveryConfigFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigPatchOrCreateRaw(requestParameters: DeliveryConfigPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigPatchOrCreate(requestParameters: DeliveryConfigPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts deliveryFees of DeliveryConfig.
     */
    async deliveryConfigPrototypeCountDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeCountDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeCountDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts deliveryFees of DeliveryConfig.
     */
    async deliveryConfigPrototypeCountDeliveryFees(requestParameters: DeliveryConfigPrototypeCountDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.deliveryConfigPrototypeCountDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in deliveryFees of this model.
     */
    async deliveryConfigPrototypeCreateDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeCreateDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeCreateDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewDeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in deliveryFees of this model.
     */
    async deliveryConfigPrototypeCreateDeliveryFees(requestParameters: DeliveryConfigPrototypeCreateDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryConfigPrototypeCreateDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all deliveryFees of this model.
     */
    async deliveryConfigPrototypeDeleteDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeDeleteDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeDeleteDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all deliveryFees of this model.
     */
    async deliveryConfigPrototypeDeleteDeliveryFees(requestParameters: DeliveryConfigPrototypeDeleteDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deliveryConfigPrototypeDeleteDeliveryFeesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeDestroyByIdDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeDestroyByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeDestroyByIdDeliveryFees().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling deliveryConfigPrototypeDestroyByIdDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeDestroyByIdDeliveryFees(requestParameters: DeliveryConfigPrototypeDestroyByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deliveryConfigPrototypeDestroyByIdDeliveryFeesRaw(requestParameters, initOverrides);
    }

    /**
     * Find a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeFindByIdDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeFindByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeFindByIdDeliveryFees().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling deliveryConfigPrototypeFindByIdDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeFindByIdDeliveryFees(requestParameters: DeliveryConfigPrototypeFindByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryConfigPrototypeFindByIdDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryConfigPrototypeGetCourierRaw(requestParameters: DeliveryConfigPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryConfigPrototypeGetCourier(requestParameters: DeliveryConfigPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.deliveryConfigPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries deliveryFees of DeliveryConfig.
     */
    async deliveryConfigPrototypeGetDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeliveryFee>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeGetDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeliveryFeeFromJSON));
    }

    /**
     * Queries deliveryFees of DeliveryConfig.
     */
    async deliveryConfigPrototypeGetDeliveryFees(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeliveryFee>> {
        const response = await this.deliveryConfigPrototypeGetDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryConfigPrototypeGetDeliveryFeesCourierRaw(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeGetDeliveryFeesCourier().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling deliveryConfigPrototypeGetDeliveryFeesCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/{nk}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryConfigPrototypeGetDeliveryFeesCourier(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.deliveryConfigPrototypeGetDeliveryFeesCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation towns.
     */
    async deliveryConfigPrototypeGetDeliveryFeesTownsRaw(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Town>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeGetDeliveryFeesTowns().'
            );
        }

        if (requestParameters['nk'] == null) {
            throw new runtime.RequiredError(
                'nk',
                'Required parameter "nk" was null or undefined when calling deliveryConfigPrototypeGetDeliveryFeesTowns().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/{nk}/towns`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"nk"}}`, encodeURIComponent(String(requestParameters['nk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TownFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation towns.
     */
    async deliveryConfigPrototypeGetDeliveryFeesTowns(requestParameters: DeliveryConfigPrototypeGetDeliveryFeesTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Town> {
        const response = await this.deliveryConfigPrototypeGetDeliveryFeesTownsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigPrototypePatchAttributesRaw(requestParameters: DeliveryConfigPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigPrototypePatchAttributes(requestParameters: DeliveryConfigPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeUpdateByIdDeliveryFeesRaw(requestParameters: DeliveryConfigPrototypeUpdateByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryFee>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigPrototypeUpdateByIdDeliveryFees().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling deliveryConfigPrototypeUpdateByIdDeliveryFees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/deliveryFees/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryFeeToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryFeeFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for deliveryFees.
     */
    async deliveryConfigPrototypeUpdateByIdDeliveryFees(requestParameters: DeliveryConfigPrototypeUpdateByIdDeliveryFeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryFee> {
        const response = await this.deliveryConfigPrototypeUpdateByIdDeliveryFeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigReplaceByIdPostDeliveryConfigsidReplaceRaw(requestParameters: DeliveryConfigReplaceByIdPostDeliveryConfigsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigReplaceByIdPostDeliveryConfigsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigReplaceByIdPostDeliveryConfigsidReplace(requestParameters: DeliveryConfigReplaceByIdPostDeliveryConfigsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigReplaceByIdPostDeliveryConfigsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigReplaceByIdPutDeliveryConfigsidRaw(requestParameters: DeliveryConfigReplaceByIdPutDeliveryConfigsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryConfigReplaceByIdPutDeliveryConfigsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryConfigReplaceByIdPutDeliveryConfigsid(requestParameters: DeliveryConfigReplaceByIdPutDeliveryConfigsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigReplaceByIdPutDeliveryConfigsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreateRaw(requestParameters: DeliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreate(requestParameters: DeliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigReplaceOrCreatePostDeliveryConfigsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigReplaceOrCreatePutDeliveryConfigsRaw(requestParameters: DeliveryConfigReplaceOrCreatePutDeliveryConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryConfigReplaceOrCreatePutDeliveryConfigs(requestParameters: DeliveryConfigReplaceOrCreatePutDeliveryConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigReplaceOrCreatePutDeliveryConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryConfigUpdateAllRaw(requestParameters: DeliveryConfigUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryConfigUpdateAll(requestParameters: DeliveryConfigUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.deliveryConfigUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryConfigUpsertWithWhereRaw(requestParameters: DeliveryConfigUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryConfig>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryConfigs/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryConfigToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryConfigFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryConfigUpsertWithWhere(requestParameters: DeliveryConfigUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryConfig> {
        const response = await this.deliveryConfigUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
